import { render, staticRenderFns } from "./question-control-replace.vue?vue&type=template&id=49b136a2&scoped=true&"
import script from "./question-control-replace.vue?vue&type=script&lang=js&"
export * from "./question-control-replace.vue?vue&type=script&lang=js&"
import style0 from "./question-control-replace.vue?vue&type=style&index=0&id=49b136a2&prod&lang=scss&"
import style1 from "./question-control-replace.vue?vue&type=style&index=1&id=49b136a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b136a2",
  null
  
)

export default component.exports